import { memo } from 'react';
import dayjs from 'dayjs';

import { HeaderType } from '@utils/types';
import { QrCreateSequence } from '@graphql/types';

import { TableRow, TableCell } from '@components/share/Table/table.style';

type QrListTableRowType = {
    header: HeaderType[];
    data: QrCreateSequence;
};

const QrListTableRow = ({ header = [], data }: QrListTableRowType) => {
    return (
        <TableRow $default>
            <TableCell $minWidth={header[0].minWidth} $width={header[0].width}>
                {data?.qrcsId || '-'}
            </TableCell>
            <TableCell $minWidth={header[1].minWidth} $width={header[1].width}>
                {data?.createdAt
                    ? dayjs(data.createdAt).format('YYYY-MM-DD')
                    : '-'}
            </TableCell>
            <TableCell $minWidth={header[2].minWidth} $width={header[2].width}>
                {typeof data?.amount === 'number' ? data?.amount : '-'}
            </TableCell>
            <TableCell $minWidth={header[3].minWidth} $width={header[3].width}>
                {typeof data?.usedAmount === 'number' ? data?.usedAmount : '-'}
            </TableCell>
            <TableCell $minWidth={header[4].minWidth} $width={header[4].width}>
                {typeof data?.unUsedAmount === 'number'
                    ? data?.unUsedAmount
                    : '-'}
            </TableCell>
            <TableCell $minWidth={header[5].minWidth} $width={header[5].width}>
                {typeof data?.usedRatio === 'number'
                    ? `${data?.usedRatio}%`
                    : '-'}
            </TableCell>
            <TableCell
                $minWidth={header[6].minWidth}
                $width={header[6].width}
                onClick={() => window.open(data?.zipImgUrl as string)}
                $cursor
            >
                이미지 다운로드
            </TableCell>
        </TableRow>
    );
};

export default memo(QrListTableRow);
